export const keyConstants = {
  EXPIRY_TOKEN_TIME: "auth_expiry",
  AUTH_TOKEN: "acc_key",
  DEFAULT_PAGE_SIZE: 40,
};
